import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FolderTree = ({ folders, selectedFolder, onFolderSelect, onCreateFolder }) => {
  const [expandedFolders, setExpandedFolders] = useState(new Set(['root']));

  const toggleFolder = (folderId) => {
    const newExpanded = new Set(expandedFolders);
    if (newExpanded?.has(folderId)) {
      newExpanded?.delete(folderId);
    } else {
      newExpanded?.add(folderId);
    }
    setExpandedFolders(newExpanded);
  };

  const renderFolder = (folder, level = 0) => {
    const isExpanded = expandedFolders?.has(folder?.id);
    const isSelected = selectedFolder === folder?.id;
    const hasChildren = folder?.children && folder?.children?.length > 0;

    return (
      <div key={folder?.id}>
        <div
          className={`flex items-center space-x-2 px-3 py-2 rounded-lg cursor-pointer transition-colors duration-150 ${
            isSelected ? 'bg-primary/10 text-primary' : 'hover:bg-muted/50 text-foreground'
          }`}
          style={{ paddingLeft: `${12 + level * 20}px` }}
          onClick={() => onFolderSelect(folder?.id)}
        >
          {hasChildren && (
            <button
              onClick={(e) => {
                e?.stopPropagation();
                toggleFolder(folder?.id);
              }}
              className="p-1 hover:bg-muted rounded"
            >
              <Icon 
                name={isExpanded ? 'ChevronDown' : 'ChevronRight'} 
                size={14} 
              />
            </button>
          )}
          {!hasChildren && <div className="w-6" />}
          
          <Icon 
            name={isExpanded ? 'FolderOpen' : 'Folder'} 
            size={16} 
            className={isSelected ? 'text-primary' : 'text-muted-foreground'}
          />
          
          <span className="flex-1 text-sm font-medium">{folder?.name}</span>
          
          <span className="text-xs text-muted-foreground bg-muted px-2 py-1 rounded-full">
            {folder?.documentCount}
          </span>
        </div>
        {hasChildren && isExpanded && (
          <div>
            {folder?.children?.map(child => renderFolder(child, level + 1))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="h-full bg-surface border-r border-border">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-foreground">Folders</h2>
          <button
            onClick={onCreateFolder}
            className="p-2 hover:bg-muted rounded-lg transition-colors duration-150"
            title="Create New Folder"
          >
            <Icon name="FolderPlus" size={16} className="text-muted-foreground" />
          </button>
        </div>
      </div>
      <div className="p-2 space-y-1 overflow-y-auto" style={{ height: 'calc(100% - 80px)' }}>
        {folders?.map(folder => renderFolder(folder))}
      </div>
    </div>
  );
};

export default FolderTree;